export default "__VITE_ASSET__TvV8Ds6p__"